export default {"src":"/_next/static/media/map-large-image.1d7224f3.svg","height":598,"width":1158};